import {
    Row,
    Col,
    Typography
} from "antd"

import { useEffect, useState } from "react";
// import { appointmentData } from "./modules";
import { SearchInput, SearchResults, StyledImage, StyledSpan } from "@/components/search"

import styled from "styled-components";
import { useScreenSizeUpdated } from "@/utils/media";

const StyledRepairs = styled(Col)`
    .search-data {
        display: flex;
        min-width: 100%;
    }
    .search-data-item-col {
        @media (max-width: 420px) {
            min-width: 100%;
        }
        @media (min-width: 421px) {
            min-width: 50%;
            // min-width: ${props => props.searchitemwidth ? `${props.searchitemwidth}px` : '295px'};
        }
    }
    .search-data-item, .search-data-button {
        display: flex;

        height: 76px;
        min-width: 100%;
        border-radius: 8px;
    }
    .search-data-details{
        width: 100%;
        height: 100%;
    }
    .search-data-name{
        margin: 10px 0 0 10px;
        display: flex;
        justify-content: start;
        color: #404040;
        font-weight: bold;
        font-family: 'Montserrat';
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.01em;
        max-width: 170px;
        text-align: left;

    }
    .search-data-guarantee {
        margin: 0 0 0 10px;
        display: flex;
        justify-content: start;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: #707070;

    }
    .search-data-price{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:3px;
        mnin-width: 72px;
        border: 1px solid var(--primary-main-color);
        border-radius: 8px;
    }
    .search-data-currency{
        display: inline-flex;
        margin-top: -5px;
        font-weight: bold;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.01em;
        color: var(--primary-main-color);
    }
    .search-data-price-value{
        display: inline-flex;
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.01em;
        color: var(--primary-main-color);

    }
    .search-data-item-selected .search-data-price {
    }
    .price-on-request .search-data-price-value {
        display:flex;
        font-size: 12px;
        line-height: 16px;
        margin-top: 2px;
        margin-bottom: 2px;

    }
    .price-on-request {
        min-width: 60px;
        display: flex;
    }
    .search-data-item-selected  {
        .search-data-guarantee, .search-data-name {
            color: #fff;
        }
        .search-data-price {
            color: #fff;
            background-color: #fff;
        }
        
        .search-data-item, .search-data-button {
            background-color: var(--primary-main-color);
        }
    }
`
const StyledBox = styled.div`
`

export const RepairPrice = ({ repair }) => {
    console.log(repair.price)
    if (repair.result?.price === 0) {
        return <StyledBox className="search-data-price  price-on-request">
            {/* <StyledBox className='search-data-currency'>€</StyledBox> */}
            <StyledBox className='search-data-price-value'>Prijs op aanvraag</StyledBox>
        </StyledBox>

    }
    return <StyledBox className="search-data-price">
        <StyledBox className='search-data-currency'>€</StyledBox>
        <StyledBox className='search-data-price-value'>{repair.result.price}</StyledBox>
    </StyledBox>

}
const SearchItemContent = ({ item }) => {
    // console.log(item)
    return <Row type="flex" justify="space-between" align="start" className="search-data-details" gutter={16} style={{ justifySelf: "center" }}>
        <Col span={16}>
            <StyledBox className='search-data-name'>{item.name}</StyledBox>
            <StyledBox className='search-data-guarantee'>{item.result.reparation_time} minuten</StyledBox>
        </Col>
        <Col span={8} style={{ alignSelf: 'center', justifySelf: 'center' }}>
            <RepairPrice repair={item} />
        </Col>
    </Row>

}

const SearchRepairs = ({ searchModule, searchPlaceholder }) => {
    const screenSize = useScreenSizeUpdated()

    const [maxItems, setMaxItems] = useState()
    const [searchItemWidth, setSearchItemWidth] = useState(295)
    useEffect(() => {
        async function loadData() {
            const results = await searchModule.actions.fetch_results()
            // console.log(results)
        }
        loadData()
        // console.log('search repairs...')
        setMaxItems(screenSize === 'mobile' ? 3 : 6)
    }, []);
    // console.log(maxItems)
    return <Row gutter={0} style={{ justifySelf: 'center' }} justify='center'>
        <StyledRepairs span={24} className="search-repairs" searchitemwidth={searchItemWidth}>
            {/* <SearchInput searchModule={searchModule} searchPlaceholder={searchPlaceholder} /> */}
            <SearchResults
                searchModule={searchModule}
                maxItems={maxItems}
                SearchItemContent={SearchItemContent} />
        </StyledRepairs>
    </Row>

}
export default SearchRepairs;
export { SearchItemContent, StyledRepairs };
